import { render, staticRenderFns } from "./CategoryListView.vue?vue&type=template&id=3c267a6a&scoped=true"
import script from "./CategoryListView.vue?vue&type=script&lang=js"
export * from "./CategoryListView.vue?vue&type=script&lang=js"
import style0 from "./CategoryListView.vue?vue&type=style&index=0&id=3c267a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c267a6a",
  null
  
)

export default component.exports